var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home overflow-hidden"},[_c('AboutUsHero'),_c('AboutThreeCard'),_c('ProfileHero')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }